module.exports = __webpack_public_path__ + "static/frmk-9d3afe68aaae9c35c507a0e5504079b1.png";